import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-tracking';

import Feature from '../Feature';
import { useModalHandle } from '../../utils/withModalHandle';
import InstantBookingModal from '../../InstantBookingModal';
import InstantBookingLabelCircledIcon from '../../icons/InstantBookingLabelCircledIcon';
import { INSTANT_BOOKING_FEATURE } from '../featureList';

import styles from '../ValuePropositionFeatures.module.scss';

const InstantBookingFeature = ({ rules, onCollapsedChange, collapsed }) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();

  const handleIBModalOpen = e => {
    e.preventDefault();
    Metrics.hotjar.triggerEvent('listing-IB-modal-click');
    handleModalOpen();
  };

  const renderBody = () => (
    <Fragment>
      <div
        role="button"
        tabIndex={-1}
        className={`${styles['instant-booking__body']} ga-instant-booking-ru-conditions`}
        onClick={handleIBModalOpen}
        dangerouslySetInnerHTML={{
          __html: trans('property_show.book_now_card.instant_booking.body')
        }}
      />
      <InstantBookingModal
        isOpen={isModalOpen}
        handleModalClose={handleModalClose}
        rules={rules}
      />
    </Fragment>
  );

  return (
    <Feature
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      featureName={INSTANT_BOOKING_FEATURE}
      renderBody={renderBody}
      renderIcon={() => <InstantBookingLabelCircledIcon />}
      headerKey="property_show.book_now_card.instant_booking"
    />
  );
};

InstantBookingFeature.propTypes = {
  rules: PropTypes.shape({
    params: PropTypes.shape(),
    type: PropTypes.string
  }).isRequired,
  collapsed: PropTypes.bool.isRequired,
  onCollapsedChange: PropTypes.func.isRequired
};

export default InstantBookingFeature;
